<script>
    import { PowerTable } from "@muonw/powertable";
    import { locale, format} from 'svelte-i18n';

    let {
        data = [],
        instructs = [],
        prefix,
        rowsPerPage = 10,
        parseFunc = x => x
    } = $props();

    let tableElement = $state();

    let selected_rows = [];


    let ptOptions = $state({
        uniquePrefix: prefix,
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: rowsPerPage,
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
        'topBar': ['search'],
        'pTable': ['table'],
        'bottomBar': ['dropdown', 'stats', 'pagination'],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        /*userFunctions: {
            customParse: parseFunc
        }*/
    })

    const selectRow = (event) =>{
        //tables have no relevant actions for selection except userTable
        if(prefix != 'userTable') return;
        let selection = event.detail.data;
        let idx = selected_rows.findIndex(r=> r.id == selection.id);
        if(idx > -1){
            selected_rows.splice(idx, 1);
            let row = document.querySelector(`[data-index='${selection.__PT_ID__}']`);
            row.classList.remove('selected')
        }
        else {
            selected_rows.push(selection);
            let row = document.querySelector(`[data-index='${selection.__PT_ID__}']`);
            row.classList.add("selected");
        }
    }

    const exportToCSV = async ()=> {
        let instructsCopy = JSON.parse(JSON.stringify(instructs));
        let header = [];
        let titles = [];
        const data = tableElement.getData(false, "matchedData").matchedData;
        let items = JSON.parse(JSON.stringify(data));

        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here

        instructsCopy.forEach(col=>{
            if(col.key != 'select'){
                header.push({key: col.key, value: col.title});
            }

            if(col.title.includes(" ")) col.title = col.title.replace(' ', '_');
            if(col.key != 'select'){
                titles.push(col.title == "En alcance" ? "Alcance" : col.title);
            }
        });

        const csv = [
            titles.join(';'), // header row first
            ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName["key"]], replacer)).join(';'))
        ].join('\r\n');

        let hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = `${translatePrefix()}_vulseek.csv`;
        hiddenElement.click();
    }

    const showContent = (kind, id)=>{
        let visibleElement = document.getElementById(kind + '-visible-' + id);
        let hiddenElement  = document.getElementById(kind + '-hidden-'  + id);
        visibleElement.classList.remove('is-visible');
        visibleElement.classList.add('is-hidden');
        hiddenElement.classList.remove('is-hidden');
        hiddenElement.classList.add('is-visible');
    }

    const hideContent = (kind, id)=>{
        let visibleElement = document.getElementById(kind + '-visible-' + id);
        let hiddenElement  = document.getElementById(kind + '-hidden-'  + id);
        visibleElement.classList.add('is-visible');
        visibleElement.classList.remove('is-hidden');
        hiddenElement.classList.add('is-hidden');
        hiddenElement.classList.remove('is-visible');
    }

    const translatePrefix = () =>{
        let translations = {
            billingTable: 'Consumos',
            logsTable: 'Logs'
        }
        return translations[prefix] || 'csv';
    }

    window.showContent = showContent;
    window.hideContent = hideContent;

    let tableTranslations = $derived(getTableTranslations($locale));
</script>
<style>
</style>

<button class="btn btn-secondary table-button btn-export btn-xs t-csv-billing-btn float-end" tabindex="0" aria-controls="billingTable" type="button" title={$format("buttons.csv")} id="billingCSVbtn" onclick={exportToCSV}><i class="fa fa-file-csv" style="font-size: 18px;"></i></button>
<PowerTable ptData={data} ptInstructs={instructs} {ptOptions} on:rowClicked="{e=>selectRow(e)}" bind:this={tableElement}>
    {#snippet noResults()}
        <div >
            {$format("results_not_found")}
        </div>
    {/snippet}
</PowerTable>
